module.exports = __webpack_public_path__ + "static/young-leader-photo-yomna_ibrahim-9f74454f9816780a2cf151aa251d38a9.jpg";